import { object, string } from "yup";

import { PromotionCampaignStatusEnum } from "../status";

export const DEFAULT_VALUES = {
  name: "",
  description: "",
  status: PromotionCampaignStatusEnum.DRAFT,
};

export const VALIDATION_SCHEMA = object().shape({
  name: string().required("Harus diisi"),
  description: string(),
  status: string().required("Harus diisi"),
});
